module.exports = __webpack_public_path__ + "static/img/zhutu收获机.99025c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhutu收获机.png
// module id = WcGJ
// module chunks = 0